
import React from 'react'
import { WrapIconButton } from './Styled'
import { gTheme } from 'styles/theme';

const CustomIconButton = (props) => {
    const { variant, hideFill, transparent, className, gridArea, border, arrayIndex, onDoubleClick, height, width, icon, disabled, label, color, action, $bg, size, $border } = props;

    return (
        <WrapIconButton
            transparent={transparent}
            gridArea={gridArea ? `${gridArea}_${arrayIndex}` : null}
            size={size}
            onDoubleClick={onDoubleClick}
            width={width}
            height={height}
            className={`${className ? className : ""} ${variant ? variant : ""}`}
            onClick={() => action(props)}
            $border={$border}
            color={color}
            themeColor={gTheme[color]}
            $bg={$bg}
            $disabled={typeof disabled == 'function' ? disabled(arrayIndex) : disabled}
            $hideFill={hideFill}
        >
            {icon}
            {label}
        </WrapIconButton>
    )
}

export default CustomIconButton